import { Icon } from "@resource/atlas";
import { atlasClock } from "@resource/atlas/icons";

type Props = {
  date: Date;
};

export function UpdatedDate({ date }: Props) {
  return (
    <div className="text-body-md text-subtle flex space-x-2 items-center">
      <Icon content={atlasClock} size="small" />
      <span>
        Updated{" "}
        {date.toLocaleString("en-US", {
          month: "short",
          day: "numeric",
        })}
      </span>
    </div>
  );
}
